<div class="header_fixed">
  <mat-toolbar class="background-header-color">
    <div class="">
      <img src="../../../assets/logo/logo.png" width="218px" />
    </div>
    <span class="title" routerLink="/"></span>
    <!-- <button class="action_button" (click)="menuToggled.emit(true)" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button> -->
    <ng-container *ngIf="userdata?.data?.sub_orgs_data?.length > 0">
      <div class="ms-4 cursor_pointer" [matMenuTriggerFor]="Submenu" *ngIf="userdata.data?.org_level_user == 1">
        <img src="../../../assets/icons/suborg_Icon.svg" />
      </div>
      <div class="ms-4 cursor_pointer" *ngIf="userdata.data?.org_level_user == 0">
        <!-- <img src="../../../assets/icons/suborg_Icon.svg" /> -->
      </div>
      <ng-container *ngIf="selected_sub_org">
        <div class="ms-2">
          <!-- <img [src]="assetUrl + assetContainer + selected_sub_org.logo_url" /> -->
          <p class="m-0">{{selected_sub_org.sub_organization_name}}</p>
        </div>
      </ng-container>
      <mat-menu #Submenu="matMenu">
        <div *ngFor="let suborgsdata of userdata?.data?.sub_orgs_data; let i = index; last as isLast">
          <div class="hr_line my-2 cursor_pointer"
            [ngStyle]="{'border-left': selected_sub_org?.id == suborgsdata?.id ? '4px solid #0056B5' : 'none'} ">
            <div class="px-3 py-2 action_button line-height-15" (click)="Storesuborgdata(suborgsdata)">
              <p class="m-0 fs-14"> {{suborgsdata?.sub_organization_name}}</p>
              <small class="m-0 fs-12 text_color_light"> {{suborgsdata?.city}}</small>
            </div>
            <!-- <hr *ngIf="!isLast" class="hr_position text_color_light my-2"/> -->
          </div>
          <mat-divider *ngIf="!isLast" class="hr_position text_color_light my-2 mx-3"></mat-divider>
        </div>
      </mat-menu>
    </ng-container>
    <span class="spacer"></span>
    <select class="form-select theme_select me-1" [value]="selectedlang" #langSelect (change)="switchLang(langSelect.value || 'en')">
     <!-- <option value="hn">हिन्दी</option> -->
      <option value="en">English</option>
      <option value="te">తెలుగు</option>
    </select>
    <select  class="form-select theme_select" [value]="selectedTheme" (change)="changeTheme($event)">
      <option value="default">Light</option>
      <option value="dark-theme">Dark</option>
      <!-- <option value="custom-theme">Custom</option> -->
    </select>
    <span class="disable icon_dark_light">
      <i class="px-1 fa-solid fa-bell"></i>
    </span>
    <span class="disable icon_dark_light">
      <i class="px-1 fa-solid fa-comments"></i>
    </span>
    <span [matMenuTriggerFor]="menu" class="icon_dark_light d-flex align-items-center">
      <span>
        <i class="px-1 fa-solid fa-circle-user"></i>
      </span>
      <span class="welcome-text">{{ user }}</span>
    </span>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="gotoprofile()">
        <span>Profile</span>
      </button>
      <button mat-menu-item (click)="logout()">
        <span>Logout</span>
      </button>
    </mat-menu>

  </mat-toolbar>
</div>
<div class="scrolling-text-container p-1" style="display: none;">
  <div class="scrolling-text">
    This is a continuous scrolling text. Here you can display important announcements or updates for your users.
  </div>
</div>